export enum TruckingRouteActions {
    CreateEmptyRoute = "CreateEmptyRoute",
    RemoveRoute = "RemoveRoute",
    BrokenRoute = "BrokenRoute",
    UnBrokenRoute = "UnBrokenRoute",
    ConfirmedRoute = "ConfirmedRoute",
    DesconfirmedRoute = "DesconfirmedRoute",

    AddShipment = "AddShipment",
    TruckingShipment = "TruckingShipment",
    
    AddPackage = "AddPackage",
    RemovePackage = "RemovePackage",

    None = "None"

}
